var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.28259 11.8462C0.794438 12.3344 0.794437 13.1258 1.28259 13.614C1.77075 14.1021 2.5622 14.1021 3.05036 13.614L1.28259 11.8462ZM13.4802 1.41637H14.7302C14.7302 0.726016 14.1705 0.166372 13.4802 0.166372V1.41637ZM12.2302 11.3159C12.2302 12.0062 12.7898 12.5659 13.4802 12.5659C14.1705 12.5659 14.7302 12.0062 14.7302 11.3159H12.2302ZM4.2878 0.166372C3.59744 0.166372 3.0378 0.726016 3.0378 1.41637C3.0378 2.10673 3.59744 2.66637 4.2878 2.66637V0.166372ZM3.05036 13.614L14.3641 2.30026L12.5963 0.532489L1.28259 11.8462L3.05036 13.614ZM12.2302 1.41637V11.3159H14.7302V1.41637H12.2302ZM13.4802 0.166372H4.2878V2.66637H13.4802V0.166372Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightUp);
export default __webpack_public_path__ + "static/media/arrow-right-up.56d0ebbc5b720f1e1d2c892975128b27.svg";
export { ForwardRef as ReactComponent };